import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LanguageRouteService } from './shared/services/language-route.service';

@Component({
  selector: 'go-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  // Recursively find 'lang' param in the route tree
  private getLangFromRoute(route: any): string | null {
    if (route && route.params && route.params['lang']) {
      return route.params['lang'];
    }
    if (route && route.children && route.children.length) {
      for (let child of route.children) {
        const lang = this.getLangFromRoute(child);
        if (lang) return lang;
      }
    }
    return null;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private languageRoute: LanguageRouteService
  ) {
    this.translate = translate
    translate.addLangs(['de', 'en', 'fr', 'nl', 'lb']);
    translate.setDefaultLang('de');
    const browserLang = translate.getBrowserLang();
    translate.use(['de', 'en', 'fr', 'nl', 'lb'].includes(browserLang) ? browserLang : 'de');

    // Listen to route changes and set language from :lang param (robust for all depths)
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      const lang = this.getLangFromRoute(this.route.snapshot);
      console.log('Detected lang from route:', lang); // DEBUG
      if (lang && ['de','en','fr','nl','lb'].includes(lang)) {
        this.translate.use(lang);
      } else {
        this.switchLang('de')
      }
    });
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    this.languageRoute.switchLanguageInCurrentRoute(lang);
  }

  isProduction() {
    return environment.production
  }
}
